/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dropdown } from "react-bootstrap";
import IcomoonIcon from "@icons/IcomoonIcon";
import SntViewerDisable from "@icons/SntViewerDisable";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";

interface ConfigActionsProps {
  column: any;
  dataFilter: any;
  onConfigColumn?: () => void;
}

export const ConfigActions = ({
  column,
  dataFilter,
  onConfigColumn,
}: ConfigActionsProps) => {
  if (!onConfigColumn) return null;

  const handleHideColumn = () => {
    dataFilter?.removeColumnKey?.(column.key);
  };

  const handleConfigureView = (e: React.MouseEvent) => {
    e.preventDefault();
    onConfigColumn();
  };

  return (
    <>
      <Dropdown.Item bsPrefix="dropdown-item" onClick={handleHideColumn}>
        <div className="d-flex">
          <div style={{ width: 20 }} className="d-flex align-items-center">
            <SntViewerDisable />
          </div>
          <div>{translate(LanguageKey.hide_column_key)}</div>
        </div>
      </Dropdown.Item>
      <Dropdown.Item bsPrefix="dropdown-item" onClick={handleConfigureView}>
        <div className="d-flex">
          <div style={{ width: 20 }} className="d-flex align-items-center">
            <IcomoonIcon icon="cog" size="16" />
          </div>
          <div>{translate(LanguageKey.configure_view_key)}</div>
        </div>
      </Dropdown.Item>
      <Dropdown.Divider className="table-group-menu-divider" />
    </>
  );
};
